//window.onpageshow = function() {
//  $("#name_sei,#name_mei").each(function(){
//    $(this).val("");
//  });
//}

//window.onunload = function() {};

$(function(){

  formAction.emailImitater();
  formAction.creditcardField();

  $('#order-form').validationEngine('attach', {
    promptPosition:"topLeft"
  });

  $.fn.autoKana('#name_sei', '#name_sei_kana', {katakana:false});
  $.fn.autoKana('#name_mei', '#name_mei_kana', {katakana:false});

  $('.alphabet').change(function(){
    var txt  = $(this).val();
    var han = txt.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
    $(this).val(han);
  });

  $('#email').focusin(function(e) {
      $("#email").val($.trim($("#email").val()));
  }).focusout(function(e) {
      $("#email").val($.trim($("#email").val()));
  });

  // 画面を閉じる/移動時に警告
  var finishFlag;
  if($('input').is('*')) {
    $(window).on('beforeunload',function(){
      return('ご注文が確定していませんが移動してもよろしいですか？');
    });
  }
  $('form').on('submit',function(){
    $(window).off('beforeunload');
  });

});

formAction = function (){};

// 必須入力項目の入力チェック
formAction.checkPattern = function(){

  $('[required]').on('keyup change', function(e){

    // メールアドレスはドコモ/auのRFC2822非準拠のものもチェックして警告
    if ($(this).attr("id") == "email"){
      $('#email').popover({
        placement: "top",
        title: "ご利用いただけません",
        content: "メールアドレスの国際ルールに沿ったアドレスではなく、お客様へのメールがうまく配信されない恐れがあるため、ご利用いただけません。@の前に.をつけないか、連続した.を使わないアドレスをご利用ください",
        trigger:   "manual"
      });

      if ((/\.@/.test($(this).val()) || /\.{2,}/.test($(this).val())) && /@(docomo|ezweb)/.test($(this).val())){
        $('#email').popover("show");
      }  else{
        $('#email').popover("hide");
      }
    }

    // 通常はcheckXxxxx()
    if (e.type == "keyup") checkInput($(this));
    if (e.type == "change") checkSelect($(this));

  });

  $('.required input[type="radio"]:radio').on('click onkeypress', function (e){
    checkRadio($(this));
  });

  $('.required input[type="checkbox"]:checkbox').on('click onkeypress', function (){
    checkCheckbox($(this));
  });

  // 入力チェック pattern属性があればtest()、なければ無条件OK
  var checkInput = function (elm){

    if (checkAttr(elm, "pattern")){
      var regex = new RegExp ("^"+elm.attr("pattern")+"$");
      if (regex.test(elm.val()) == true){
        setStatus(elm, "dealed");
      } else if(elm.val() == ""){
        setStatus(elm, "alert");
      } else{
        setStatus(elm, "caution");
      }
    } else{
      if (elm.val() != ""){
        setStatus(elm, "dealed");
      }
    }

  };

  var checkSelect = function (elm){
    setStatus(elm, "dealed");
  };

  var checkRadio = function (elm){
    setStatus(elm.parents(".required"), "dealed");
  };

  var checkCheckbox = function (elm){
    var checked = false;
    // チェックボックスのどれか1つにチェックが入っていればOK
    elm.parents(".required").find(".checkbox").each(function(){
      if ($(this).find("input").is(":checked")){
        setStatus(elm.parents(".required"), "dealed");
        checked = true;
      }
    });
    if (checked == true) return;
    setStatus(elm.parents(".required"), "alert");
  };

};

// 確認用メールアドレスをインクリメンタルコピペ
formAction.emailImitater = function(){

  $('#email').on('keyup', function(){

    $("#email_confirm").parent().parent().removeClass("hide");
    $("#email_confirm").text($(this).val());

  });

};

// クレジットカード番号のフォーマット
formAction.creditcardField = function(){
  if( $("#paymentMethod input:radio:eq(0)").prop('checked') ) {
    $("#creditcard").show();
    $("#creditcard_info").show();
    $("#bank_info").hide();

    if( $("#paymentPlan option:selected").val() == 1 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c1);
        $("#amount").html(text_c1);
        $('#cc_description').hide();
      });
    } else if( $("#paymentPlan option:selected").val() == 3 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c3);
        $("#amount").html(text_c3);
        $('#cc_description').html(desc_c3).show();
      });
    } else if( $("#paymentPlan option:selected").val() == 6 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c6);
        $("#amount").html(text_c6);
        $('#cc_description').html(desc_c6).show();
      });
    } else if( $("#paymentPlan option:selected").val() == 12 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c12);
        $("#amount").html(text_c12);
        $('#cc_description').html(desc_c12).show();
      });
    }

  } else {
    $("#creditcard").hide();
    $("#creditcard_info").hide();
    $("#bank_info").show();
    $(".total_amount").each(function(i) {
      $(this).html(p_b);
      $("#amount").html(text_b);
    });
  }

  $("#paymentMethod input:radio").on('click onkeypress', function(){
    if ($(this).val() == "option1"){
      $("#creditcard").show();
      $("#creditcard_info").show();
      $("#bank_info").hide();

      if( $("#paymentPlan option:selected").val() == 1 ) {
        $(".total_amount").each(function () {
          $(this).html(p_c1);
          $("#amount").html(text_c1);
          $('#cc_description').hide();
        });
      } else if( $("#paymentPlan option:selected").val() == 3 ) {
        $(".total_amount").each(function () {
          $(this).html(p_c3);
          $("#amount").html(text_c3);
          $('#cc_description').html(desc_c3).show();
        });
      } else if( $("#paymentPlan option:selected").val() == 6 ) {
        $(".total_amount").each(function () {
          $(this).html(p_c6);
          $("#amount").html(text_c6);
          $('#cc_description').html(desc_c6).show();
        });
      } else if( $("#paymentPlan option:selected").val() == 12 ) {
        $(".total_amount").each(function () {
          $(this).html(p_c12);
          $("#amount").html(text_c12);
          $('#cc_description').html(desc_c12).show();
        });
      }

    } else{
      $("#creditcard").hide();
      $("#creditcard_info").hide();
      $("#bank_info").show();
      $(".total_amount").each(function(i) {
        $(this).html(p_b);
        $("#amount").html(text_b);
      });
    }
  });


  $("#paymentPlan").on('change', function() {
    if( $("#paymentPlan option:selected").val() == 1 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c1);
        $("#amount").html(text_c1);
        $('#cc_description').hide();
      });
    } else if( $("#paymentPlan option:selected").val() == 3 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c3);
        $("#amount").html(text_c3);
        $('#cc_description').html(desc_c3).show();
      });
    } else if( $("#paymentPlan option:selected").val() == 6 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c6);
        $("#amount").html(text_c6);
        $('#cc_description').html(desc_c6).show();
      });
    } else if( $("#paymentPlan option:selected").val() == 12 ) {
      $(".total_amount").each(function () {
        $(this).html(p_c12);
        $("#amount").html(text_c12);
        $('#cc_description').html(desc_c12).show();
      });
    }
  });


  //$('.cc_number').payment('formatCardNumber');
  $('.cc_exp').payment('formatCardExpiry');
  $('.cc_csc').payment('formatCardCVC');
  $('[data-numeric]').payment('restrictNumeric');

  $('.cc_number').on('keyup', function(){
    var cardtype = $.payment.cardType($(this).val());

    if (cardtype){
      $(this).attr("data-cardtype", cardtype);
      $(this).css("background-image", 'url("/img/card_'+ cardtype +'.png")');
    }

    //if (cardtype == "amex"){
    //  $('.cc_csc')
    //    .attr("placeholder", "XXXX")
    //    .attr("maxlength", "4")
    //    .attr("pattern", "\d{4}");
    //} else{
    //  $('.cc_csc')
    //    .attr("placeholder", "XXX")
    //    .attr("maxlength", "3")
    //    .attr("pattern", "\d{3}");
    //}

  });

  $('.cc_csc').on("focus focusout", function(){
    $(this).popover({
      html: true,
      placement: "top",
      trigger: "manual",
      title: "記載場所",
      content: (($("#cc_number").attr("data-cardtype") == "amex") ? '<img src="/img/securitycode_amex.png" width="185" height="126" style="max-width: 100%;"><p>セキュリティコードはカード表面の番号右上に記載の数字4桁になります</p>' : '<img src="/img/securitycode_visa.png" width="185" height="126" style="max-width: 100%;"><p>セキュリティコードはカード裏面の署名欄に記載の数字末尾3桁になります</p>')
    }).popover("toggle");
  });

};


// 郵便番号入力後に住所に自動変換
formAction.zipConverter = function(){

  $('#zip').on('keyup', function(){

    AjaxZip2.zip2addr(this, pref, town);

  });

};


// 内部関数：要素にステータスクラスを設定
function setStatus(elm, status){

  elm.removeClass("alert caution dealed");
  elm.parent('div').removeClass('has-error');
  elm.addClass(status);
  return;

}

// 内部関数：属性存在確認
function checkAttr(elm, attr){

  return (typeof elm.attr(attr) !== 'undefined' && elm.attr(attr) !== false) ? true : false;

}

// 関数上書：複数のスクリプト読み込みに対応した$.getScript
var getScript = $.getScript;
$.getScript = function(url, fn){
  if (!$.isArray(url)) url = [url];
  $.when.apply(null, $.map(url, getScript)).done(function(){
    fn && fn();
  });
};



// Copyright (c) 2013 Keith Perhac @ DelfiNet (http://delfi-net.com)
//
// Based on the AutoRuby library created by:
// Copyright (c) 2005-2008 spinelz.org (http://script.spinelz.org/)
//
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

(function ($) {
  $.fn.autoKana = function (element1, element2, passedOptions) {

    var options = $.extend(
      {
        'katakana': false
      }, passedOptions);

    var kana_extraction_pattern = new RegExp('[^ 　ぁあ-んー]', 'g');
    var kana_compacting_pattern = new RegExp('[ぁぃぅぇぉっゃゅょ]', 'g');
    var elName,
      elKana,
      active = false,
      timer = null,
      flagConvert = true,
      input;

    elName = $(element1);
    elKana = $(element2);
    active = true;
    _stateClear();

    elName.blur(_eventBlur);
    elName.focus(_eventFocus);
    elName.keydown(_eventKeyDown);

    function start() {
      active = true;
    };

    function stop() {
      active = false;
    };

    function toggle(event) {
      var ev = event || window.event;
      if (event) {
        var el = Event.element(event);
        if (el.checked) {
          active = true;
        } else {
          active = false;
        }
      } else {
        active = !active;
      }
    };

    function _checkConvert(new_values) {
      if (!flagConvert) {
        if (Math.abs(values.length - new_values.length) > 1) {
          var tmp_values = new_values.join('').replace(kana_compacting_pattern, '').split('');
          if (Math.abs(values.length - tmp_values.length) > 1) {
            _stateConvert();
          }
        } else {
          if (values.length == input.length && values.join('') != input) {
            _stateConvert();
          }
        }
      }
    };

    function _checkValue() {
      var new_input, new_values;
      new_input = elName.val()
      if (new_input == '') {
        _stateClear();
        _setKana();
      } else {
        new_input = _removeString(new_input);
        if (input == new_input) {
          return;
        } else {
          input = new_input;
          if (!flagConvert) {
            new_values = new_input.replace(kana_extraction_pattern, '').split('');
            _checkConvert(new_values);
            _setKana(new_values);
          }
        }
      }
    };

    function _clearInterval() {
      clearInterval(timer);
    };

    function _eventBlur(event) {
      _clearInterval();
    };
    function _eventFocus(event) {
      _stateInput();
      _setInterval();
    };
    function _eventKeyDown(event) {
      if (flagConvert) {
        _stateInput();
      }
    };
    function _isHiragana(chara) {
      return ((chara >= 12353 && chara <= 12435) || chara == 12445 || chara == 12446);
    };
    function _removeString(new_input) {
      if (new_input.match(ignoreString)) {
        return new_input.replace(ignoreString, '');
      } else {
        var i, ignoreArray, inputArray;
        ignoreArray = ignoreString.split('');
        inputArray = new_input.split('');
        for (i = 0; i < ignoreArray.length; i++) {
          if (ignoreArray[i] == inputArray[i]) {
            inputArray[i] = '';
          }
        }
        return inputArray.join('');
      }
    };
    function _setInterval() {
      var self = this;
      timer = setInterval(_checkValue, 30);
    };
    function _setKana(new_values) {
      if (!flagConvert) {
        if (new_values) {
          values = new_values;
        }
        if (active) {
          var _val = _toKatakana(baseKana + values.join(''));
          elKana.val(_val);
        }
      }
    };
    function _stateClear() {
      baseKana = '';
      flagConvert = false;
      ignoreString = '';
      input = '';
      values = [];
    };
    function _stateInput() {
      baseKana = elKana.val();
      flagConvert = false;
      ignoreString = elName.val();
    };
    function _stateConvert() {
      baseKana = baseKana + values.join('');
      flagConvert = true;
      values = [];
    };
    function _toKatakana(src) {
      if (options.katakana) {
        var c, i, str;
        str = new String;
        for (i = 0; i < src.length; i++) {
          c = src.charCodeAt(i);
          if (_isHiragana(c)) {
            str += String.fromCharCode(c + 96);
          } else {
            str += src.charAt(i);
          }
        }
        return str;
      } else {
        return src;
      }
    }
  };
})(jQuery);






(function($){
  $.fn.jqKey = function(options){
    window.onhelp=function(){return false;}
    var defaults = {
      "Enter":false
      ,"Tab":false
      ,"F1":null
      ,"F2":null
      ,"F3":null
      ,"F4":null
      ,"F5":null
      ,"F6":null
      ,"F7":null
      ,"F8":null
      ,"F9":null
      ,"F10":null
      ,"F11":null
      ,"F12":null
      ,"ESC":null
    };
    var setting = $.extend(defaults,options);
    var method = function(e){

      var Focus_Move = function(df,shift){
        //フォームオブジェクトが何番目か探す
        var ln = df.length;
        var i;
        for (i=0;i<ln;i++){
          if (df[i]==obj) break;
        }
        //フォーカスを取得できないものは飛ばします
        var mv = (shift?-1:1);
        var j = (ln+i+mv) % ln;
        var Fo,Fs;
        while(true){

          Fo	=	df[j];
          Fs	=	Fo.style;
          if	(Fo.type!="hidden" &&
              Fo.style.visibility!="hidden" &&
              !Fo.disabled &&
              Fo.tabIndex!=-1 &&
              Fs.visibility!="hidden" &&
              Fs.display!="none"){
            //対象のオブジェクトを戻す
            return Fo;
          }
          j=(j+mv+ln) % ln;
        }
        //Hitしない場合
        return df[i];
      }
      var df = document.forms[0];
      var	k	=	e.keyCode;
      var	s	=	e.shiftKey;
      var	c	=	e.ctrlKey;
      var	a	=	e.altKey;
      var	obj	=	e.target;
      var blKey	=	true;
      if (!setting.Enter&&k==13) return true;
      if (!setting.Tab&&k==9) return true;
      switch(k){
        case 13:
          switch(obj.type){
            case"button":
            case"file":case"textarea":
            blKey = true;
            break;
            case"radio":case"checkbox":
//						setTimeout(function(){obj.click();},1)
//						blKey = true;
//						break;
            case"text":case"select-one":case"select-multiple":
            blKey = false;
            break;
            default:
              blKey = false;
              break;
          }
          //keyイベントを処理するもののみ抽出
          if (!blKey){
            //次のフォームオブジェクト探す
            obj = Focus_Move(df,s);
          }
          break;
        case 9:		//tab
          switch(obj.type){
            case"file":
              blKey = true;
              break;
            default:
              //次のフォームオブジェクト探す
              obj = Focus_Move(df,s);
              blKey = false;
              break;
          }

          break;
        case 8:		//backspace
          switch(obj.type){
            case"text":case"textarea":
            blKey = true;
            break;
            default:
              if(confirm("backspaceが押されました。\n前ページへ移動しますか？")){
                blKey = true;
              }else{
                blKey = false;
              }
              break;
          }

          break;
        case 27://ESC
          if(setting.ESC){
            setting.ESC();
            blKey = false;
          }
          break;
        default:
          if(k>=112&&k<=123){
            var F = setting["F"+(k-111)];
            if(F)F(obj,s,c,a);
            blKey = false;
          }
          break;
      }



      if(!blKey){
        //イベントを伝播しない
        //IE規定の動作キャンセル
        if(document.all) window.event.keyCode = 0;
        obj.focus();
        if(obj.select&&obj.type!="button") obj.select();
      }
      return blKey;
    };

    this.each(function() {
      $(this).keydown(function(e){
        var ret =method(e);
        return ret;
      });
    });
  }
})(jQuery);